import apiService from "../../api/api.service";
import {
  GetHelpCategoriesRequest,
  GetHelpCategoriesResponse,
  GetHelpContentResponse,
  SubmitHelpVoteRequest,
  SubmitHelpVoteResponse,
} from "./help.types";

/**
 * Fetch all help categories with subtopics
 * @param params - Optional search query
 */
export const fetchHelpCategories = (params?: GetHelpCategoriesRequest) => {
  return apiService.get<GetHelpCategoriesResponse>("/support", { params });
};

/**
 * Fetch help content by subtopic slug
 * @param slug - Subtopic slug
 */
export const fetchHelpContent = (slug: string) => {
  return apiService.get<GetHelpContentResponse>(`/support/content/${slug}`);
};

/**
 * Submit feedback vote for help content
 * @param data - Vote data (subtopic_id and is_useful)
 */
export const submitHelpVote = (data: SubmitHelpVoteRequest) => {
  return apiService.post<SubmitHelpVoteResponse, SubmitHelpVoteRequest>(
    "/support/vote",
    data
  );
};